<template>
  <modal :show-modal="showModal" @close-modal="closeModal" width="35" title="Password Strength">
    <div class="flex flex-col gap-4">
      <p class="">All passwords must satisfy these requirements. Passwords Must have:</p>
      <hr class="my-2">
      <ul>
        <li>Must have at least 1 upper case</li>
        <li>Must have at least 1 lower case</li>
        <li>Must have at least 1 number</li>
        <li>Must have at least 1 special character or symbol</li>
        <li>Must be at least 8 characters</li>
        <li></li>
      </ul>
      <hr class="my-2">

      <div class="flex items-end w-100">
        <base-button class="ml-auto" p="p-2" text="OK" @click="closeModal" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
      password: "",
      loggingIn: false,
      isLoggedIn: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style>
.entity-name {
  background: #dae8f6;
  padding: 0.5em;
  text-align: center;
}
</style>